module.exports = __webpack_public_path__ + "media/images/category/others-28c324e13421fa83b66f83e6479636cd.jpg";